import { Autocomplete, createTheme, Input, Modal, MultiSelect, NumberInput, PasswordInput, RangeSlider, Select, TextInput } from '@mantine/core';
import { DatePickerInput, DateTimePicker } from '@mantine/dates';

import { EORIGIN_DATE_FORMAT } from '@e-origin/shared';

const inputOverrideStyle: Record<string, any> = {
  input: {
    borderColor: '#727272',
    color: '#555454',
    fontSize: '16px',
  },
  label: {
    color: '#555454',
    fontSize: '16px',
    top: '16px',
  },
};

const COLORS = {
  BLUE: {
    LIGHTEST: 'rgb(244, 249, 255)',
    PRIMARY: 'rgb(15, 98, 152)',
  },
};

export const mantineTheme = createTheme({
  // eslint-disable-next-line max-len
  fontFamily: `'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
  headings: {
    sizes: {
      h1: {
        fontSize: '36px',
        fontWeight: '500',
      },
      h2: {
        fontSize: '30px',
        fontWeight: '500',
      },
      h3: {
        fontSize: '24px',
        fontWeight: '500',
      },
      h4: {
        fontSize: '20px',
        fontWeight: '400',
      },
      h5: {
        fontSize: '18px',
        fontWeight: '400',
      },
      h6: {
        fontSize: '16px',
        fontWeight: '400',
      },
    },
  },
  colors: {
    blue: [
      COLORS.BLUE.LIGHTEST,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
      COLORS.BLUE.PRIMARY,
    ],
  },
  black: '#000',
  white: '#fff',
  defaultRadius: 'sm',
  radius: { xs: '0.125rem', sm: '0.25rem', md: '0.5rem', lg: '1rem', xl: '2rem' },
  fontSizes: { xs: '0.75rem', sm: '0.875rem', md: '1rem', lg: '1.125rem', xl: '1.45rem' },
  spacing: { xs: '0.625rem', sm: '0.75rem', md: '1rem', lg: '1.25rem', xl: '1.5rem' },
  lineHeights: {
    xs: '1',
    sm: '1.15',
    md: '1.25',
    lg: '1.35',
    xl: '1.45',
  },
  primaryColor: 'blue',
  primaryShade: { light: 6, dark: 8 },
  components: {
    Input: Input.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    Select: Select.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    TextInput: TextInput.extend({
      defaultProps: {
        size: 'lg',
        styles: inputOverrideStyle,
      },
    }),
    PasswordInput: PasswordInput.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    Modal: Modal.extend({
      styles: {
        title: {
          fontSize: '18px',
          fontWeight: '700',
          margin: '8px 0',
        },
      },
    }),
    Autocomplete: Autocomplete.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    NumberInput: NumberInput.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    MultiSelect: MultiSelect.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    DatePickerInput: DatePickerInput.extend({
      defaultProps: {
        size: 'lg',
        valueFormat: EORIGIN_DATE_FORMAT,
      },
      styles: inputOverrideStyle,
    }),
    DateTimePicker: DateTimePicker.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: inputOverrideStyle,
    }),
    RangeSlider: RangeSlider.extend({
      defaultProps: {
        color: COLORS.BLUE.PRIMARY,
      },
    }),
  },
});
